import styled from 'styled-components';
import background from '../../assets/home/backgroundcatalog.jpeg'
import { colors } from "../../utils/colors";

export const Background = styled.div`
    position: relative;
    width: 100vw;
    min-height: 100vh;
    background: url(${background});
    background-position: right;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    padding: 0 60px;

    @media (max-width: 1200px) {
        flex-direction: column;
        padding: 100px 40px;
        min-height: 70vh;
    }

    @media (max-width: 800px) {
        padding: 100px 20px;
    }

    @media (max-width: 1200px) {
        min-height: 60vh;
    }
`;

export const SplitDiv = styled.div`
    width: 50%;

    @media (max-width: 1200px) {
        width: 100%;
    }
`;

export const CatalogueTittle = styled.h1`
    color: ${colors.BLUE};
    font-family: 'Courgette', cursive;
    margin-bottom: 10px;
`;

export const CatalogueText = styled.p`
    color: ${colors.CREAM};
    font-family: 'Markazi Text', serif;
    margin-bottom: 20px;
`;

export const CatalogueButton = styled.button`
    border: 2px solid ${colors.CREAM};
    padding: 5px 10px;
    background: transparent;
    border-radius: 5px;
    color: ${colors.BLUE};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1);
    text-transform: uppercase;

    &:hover {
        cursor: pointer;
        border: 2px solid ${colors.BLUE};
        background: ${colors.CREAM};
    }
`;

export const CatalogueImage = styled.img`
    position: absolute;
    right: 0;
    bottom: 10%;
    width: 70%;
`;

export const CatalogueImageLief = styled.img`
    position: absolute;
    right: 0;
    bottom: 0;
    width: 70%;
`;
